import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import store from "./store/store";
import CartComponent from "./components/CartComponent";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import theme from "./theme";
import Home from "./components/Home";
import AppLayout from "./components/AppLayout";
import Checkout from "./components/Checkout";
import Confirmation from "./components/Confirmation";
import AdminOrdersPage from "./adminpage/AdminOrdersPage";
import { setUserId } from "./store/userSlice";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import adminConfig from "./admin-config";

const App: React.FC = () => {
  const validateAdminKey = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const secretKey = searchParams.get("key");
    return secretKey === adminConfig.secretKey; // Replace with your actual secret key
  };
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppLayout>
          <AuthCheck />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shoppingcart" element={<CartComponent />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/admin/orders" element={validateAdminKey() ? <AdminOrdersPage /> : <Navigate to="/" replace />}/>
          </Routes>
        </AppLayout>
      </ThemeProvider>
    </Provider>
  );
};

const AuthCheck: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const auth = getAuth();

    const initializeAnonymousUser = async () => {
      if (!auth.currentUser) {
        await signInAnonymously(auth);
      }
    };

    // Initialize anonymous user session if needed
    initializeAnonymousUser();

    // Set the userId in the Redux store
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch(setUserId(user.uid));
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return null; // This component doesn't need to render anything
};

export default App;
